import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfiguration } from 'app/app-configuration';
import { Observable } from 'rxjs';

@Injectable()
export class EmployeeRewardsRestService {
  private readonly controllerUrl: string = this.appConfiguration.serverApiUrl + '/secured/reward';

  constructor(private httpClient: HttpClient,
              private appConfiguration: AppConfiguration) {
  }

  bulkPrint(rewardId: number, data: { items: number[] }): Observable<Blob> {
    return this.httpClient.post(this.controllerUrl + `/bulk-print/${rewardId}`, data, {
      responseType: 'blob'
    });
  }
}
